<template>
    <AdminPageInner v-if="content" :breadcrumbs="breadcrumbs">
        <template #heading>Content</template>
        <form @submit.prevent="onSubmit" class="space-y-6">

            <FormSection>
                <template #title>
                    Home page
                </template>

                <FormGroup
                    name="home_intro"
                    label="Home page intro copy">
                    <Wysiwyg
                        v-model="form.home_intro"
                        name="home_intro"
                        placeholder="Please enter the home page intro copy..."/>
                </FormGroup>

                <FormGroup
                    name="home_banner"
                    label="Home page banner">
                    <File
                        v-model="form.home_banner"
                        :file="content.home_banner"
                        :image="true"
                        accept="image/jpeg,image/png"/>
                </FormGroup>

                <FormGroup
                    name="home_banner_copy"
                    label="Home page banner copy">
                    <Wysiwyg
                        v-model="form.home_banner_copy"
                        name="home_intro"
                        placeholder="Please enter the home page banner copy..."/>
                </FormGroup>
            </FormSection>

            <FormSection>
                <template #title>
                    Footer
                </template>

                <FormGroup
                    name="footer_copy"
                    label="Footer copy">
                    <Wysiwyg
                        v-model="form.footer_copy"
                        name="footer_copy"
                        placeholder="Please enter the footer copy..."/>
                </FormGroup>

                <template #footer>
                    <SubmitButton
                        :submitting="form.processing"
                        :disabled="form.errors.any()">
                        Update
                    </SubmitButton>
                </template>
            </FormSection>
        </form>
    </AdminPageInner>
</template>

<script>

import axios from "axios";
import AdminPageInner from "@/Components/Layout/AdminPageInner";
import SubmitButton from "@/Components/Form/SubmitButton";
import FormSection from "@/Components/Form/FormSection";
import FormGroup from "@/Components/Form/FormGroup";
import Wysiwyg from "@/Components/Form/Wysiwyg";
import File from "@/Components/Form/File";

export default {

    name: "ContentSettingsPage",

    data() {
        return {
            content: null,
            form: this.$form({}, {resetOnSuccess: false}),
        }
    },

    provide() {
        return {
            form: this.form
        }
    },

    components: {
        AdminPageInner,
        FormSection,
        FormGroup,
        Wysiwyg,
        File,
        SubmitButton
    },

    methods: {
        setData(content) {
            this.form.withData({
                home_banner: content.home_banner ? content.home_banner.id : null,
                home_banner_copy: content.home_banner_copy,
                home_intro: content.home_intro,
                footer_copy: content.footer_copy,
            });
            this.content = content;
        },
        onSubmit() {

            if (this.form.processing) {
                return;
            }

            this.form.put(route('api.settings.content'))
                .then(async () => {
                    this.$notify.success('Content updated');
                })
                .catch(console.error);
        },
    },

    computed: {
        breadcrumbs() {
            return [
                {label: 'Admin', to: {name: 'admin'}},
                {label: 'Content settings', to: {name: this.$route.name, params: this.$route.params}},
            ];
        }
    },

    async beforeRouteEnter(to, from, next) {
        const data = (await axios.get(route('api.settings.content'), {params: to.query})).data;
        next(vm => vm.setData(data));
    },
};
</script>
